import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ILatestSocialAccountStatus } from "../../features/Configurations/Integration/interface";

export const useLatestSocialAccountStatus = (interval: number = 10000) => {
    return useQuery({
        queryKey: ["latest-social-account-status"],
        queryFn: async () => {
            const response = await httpService.get<ILatestSocialAccountStatus>(
                API_CONFIG.path.latestSocialAccountStatus
            );
            return response;
        },
        refetchInterval: (query) => {
            const data = query.state.data as ILatestSocialAccountStatus | undefined;
            if (!data?.data) return interval;
            const statuses = Object.values(data.data);
            const allFinished = statuses.length > 0 && statuses.every((s) => s === "finished");
            return allFinished ? false : interval;
        },
    });
};
